import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useAuthContext } from '@/ui/contexts/AuthContext'

import { unreadCountInstance } from '../..'
import { UnreadCountsEnum } from '../../domain/models/UnreadCountsEnum'
import { setUserNotificationsCount } from '../../services/cache/UnreadCountCacheManager'

export function useUserNotificationsCounterEvents() {
  const queryClient = useQueryClient()
  const { personaSession } = useAuthContext()

  useEffect(() => {
    if (!personaSession?.personaId) return

    const unsubscribeUserNotificationsCount =
      unreadCountInstance.getUnreadCount({
        profileId: personaSession.personaId,
        countPath: UnreadCountsEnum.enum.otherNotifications,
        onValue: (snapshot) => {
          const count = snapshot.val() as number
          setUserNotificationsCount({ count }, queryClient)
        }
      })

    return () => {
      unsubscribeUserNotificationsCount()
    }
  }, [personaSession?.personaId])
}
